import type { QueueQuarantineMessage } from '@/types'

const RELATED_ID_KEYS: ReadonlyArray<{
  label: string
  aliases: readonly string[]
}> = [
  { label: 'orderId', aliases: ['orderId', 'order_id'] },
  { label: 'paymentLogId', aliases: ['paymentLogId', 'payment_log_id'] },
  { label: 'eventId', aliases: ['eventId', 'event_id'] },
  { label: 'merchantId', aliases: ['merchantId', 'merchant_id'] },
  { label: 'detectionId', aliases: ['detectionId', 'detection_id'] },
] as const

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)

export function getQueueQuarantineRelatedIds(
  message: QueueQuarantineMessage
): Array<{ key: string; value: string }> {
  const sources = [message.error_context, message.redacted_payload]
  const values = new Map<string, string>()

  for (const source of sources) {
    if (!isRecord(source)) {
      continue
    }
    for (const { label, aliases } of RELATED_ID_KEYS) {
      if (values.has(label)) {
        continue
      }
      for (const alias of aliases) {
        const value = source[alias]
        if (typeof value === 'string' || typeof value === 'number') {
          values.set(label, String(value))
          break
        }
      }
    }
  }

  return Array.from(values, ([key, value]) => ({ key, value }))
}
